<div
  class="flex items-center gap-1 px-3 py-2.5 rounded-md cursor-pointer select-none"
  [libTooltip]="menuItem().label"
  tooltipPosition="right"
  [tooltipDisabled]="layoutService.isNavChromeExpanded()"
  tooltipClass="ml-3"
  [ngClass]="[isActive() ? 'bg-primary-900' : 'bg-primary-950', layoutService.isNavChromeExpanded() ? '' : 'justify-center']"
  (click)="onMenuClicked(menuItem())">
  <app-svg-icon class="text-white" [src]="menuItem().iconPath" [size]="20"></app-svg-icon>
  @if (layoutService.isNavChromeExpanded()) {
    <p class="w-full text-body2 text-neutral-300 px-2">{{ menuItem().label }}</p>
  }

  @if ((menuItem().submenus ?? []).length > 0) {
    <app-svg-icon class="text-white"
                  [src]="menuItem().expanded ? 'assets/icons/chevron-down.svg' : 'assets/icons/chevron-right.svg'"></app-svg-icon>
  }

</div>

@let canExpand= menuItem().expanded && (menuItem().submenus?.length ?? 0);
<div class="max-h-0 overflow-hidden transition-all duration-700 ease-in-out"
     [ngClass]="{hidden: !layoutService.isNavChromeExpanded() , 'max-h-screen': canExpand}">
  <div class="flex flex-col gap-0.5">
    @for (subMenu of menuItem().submenus ?? []; track subMenu) {
      <div (click)="onMenuClicked(subMenu)"
           class="flex items-center w-full px-3 py-4  hover:bg-primary-500 transition-all duration-700 rounded-lg">
        <span class="w-[24px]"></span>
        <p class="text-caption cursor-pointer text-neutral-100">{{ subMenu.label }}</p>
      </div>
    }
  </div>
</div>
